/* eslint-disable no-nested-ternary */
import React, { Fragment } from "react";
import BaseList from "../BaseList";
import { checkNegitive,isEmpty } from "../../common/Common";
import equal from "fast-deep-equal";
import {
  Icon,
  Popconfirm,
  Tooltip,
  Input,
  Select,
  Row,
  Col,
  Button,
  Checkbox,
} from "../../common/UIComponents";
import PropTypes from 'prop-types';
import { checkServiceExistance } from "../../helpers/common";
import DeleteIcon from "../common/DeleteIcon";
import _ from "lodash";
import I18n from "../../common/I18n";
import BaseSelect from "../common/SelectDropdowns/BaseSelect";
import GLCodeSelect from "../common/SelectDropdowns/GLCodeSelect";
import EditIcon from "../common/EditIcon";
import { EstEditGlyph, EstDeleteGlyph, EstAddGlyph } from "./estimateChargeIcons";

const { TextArea } = Input;
class InvoicesList extends BaseList {
  constructor(props) {
    super(props);
    this.state = {
      uniqRows: [],
      invoiceName: "",
      invoiceCode: !this.props.groupGlByWarehouseSetting ? this.props.defaultTransportationChargeGLCode : "",
      invoiceQuantity: 1,
      invoiceAmount: "",
      orderType:"",
      error: "",
      glCodeError: "",
      errorName: "",
      orderError:"",
      isSaved: false,
      recordForEdit: {},
      DriverSettlementApproved : this.props.DriverSettlementApproved,
      hasConsolidatedOrders : this.props.hasConsolidatedOrders,
      isLocked : this.props.isLocked,
      removeEditingVals: this.props.removeEditingVals,
      removeIndvEditingVals: this.props.removeIndvEditingVals,
      applyDriverPay: false, // Added default value for the checkbox
      isAutoChargeModified: false, // Added state to track if auto charge is modified
      isSubItemList: this.props.isSubItemList || false
      
    }
    this.columns = [];
    this.setColumns(props);
  }

  setColumns = (props) => {
    const { orderData, orderDataWithLocations, screenType = "ManageBilling" } = props;
    const dataSource = orderData?.type_of_order === "MS" && screenType === "ManageBilling" ? orderDataWithLocations : orderData;
    
    const columns = [
      {
        title: "#",
        key: "index",
        render: (text, record, index) => {
          const currentRowIndex = this.state.uniqRows.findIndex(rec => rec.id === record.id || (!isEmpty(record.order_item_group_id) && rec.order_item_group_id === record.order_item_group_id));
          const obj = {
            children: <Fragment>
              <span>{ currentRowIndex < 0 ? this.state.uniqRows.length + 1 : currentRowIndex + 1}</span>
              <div className="textBold textPrimary">{record.is_fmp_applied === 'true' ? 'FMP' : ''}</div>
            </Fragment>,
            props: {}
          };
          if(!isEmpty(record.order_item_group_id)){
            obj.props.rowSpan = this.findSpanValue(this.props.data, record, index)
            return obj;
          }
          return obj;
        },
        width: 50,
        className: 'alignCenter'
      },
      {
        key: "invoice_name",
        title: I18n.t("general.description"),
        dataIndex: "invoice_name",
        render: (data, record, index) => {
          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const isFuelEditable = this.props.invoice_type === "fuel_surcharges" ? this.props.currentProcessedId === record.id : false
          //to get percent vals from item_description string
          const match = record?.item_description ? record.item_description.match(/[\d.]+/) : "";
          const percentVal = match ? match[0] : "";
          const remainingString = record?.item_description ? record.item_description.replace(percentVal, "").trim() : "";
          //
          return (record.isNew && !this.state.isSaved) || isEditing ? (
            <Fragment>
              <Row>
                {this.props.invoice_type === "accessorial_charges" ? (
                  <Select
                    data-testid={`${this.props.dataTestId}-accessorial-dropdown`}
                    value={record.accessorial_code}
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    className="width100Per"
                    size="small"
                    onChange={(e) => {
                      this.props.handleOnChange(
                        index,
                        "accessorial_code",
                        e,
                        this.props.currentSection.order_number
                      )
                      this.setState({ invoiceName: e, invoiceCode: record.gl_code })
                    }}
                  >
                    <Select.Option value="">Select accessorial</Select.Option>
                    {this.props.reqData.map((reqRecord) => (
                      <Select.Option
                        key={reqRecord.accessorial_code}
                        value={reqRecord.accessorial_code}
                      >
                        {reqRecord.accessorial_name}
                      </Select.Option>
                    ))}
                  </Select>
                ) : (
                  <Input
                    data-testid={`${this.props.dataTestId}-description-input`}
                    value={this.state.invoiceName}
                    size="small"
                    style={{ width: this.state.isSubItemList ? "95%" : "100%" }}
                    onChange={(e) =>{
                        const newValue = e.target.value;
                        this.setState({
                          invoiceName: newValue,
                          errorName: ""
                        });
                      // Call the handleOnChange method
                      this.props.handleOnChange(
                        index,
                        "invoice_name",
                        newValue,
                        this.props.currentSection.order_number
                      )
                      // Perform the validation logic on change
                      if (this.checkInvoiceNameConflict(newValue) || this.props.hasEditingErrors) {
                          this.setState({
                            errorName: "Please change the description, it's already configured in accessorial level",
                          });
                    }
                        else {
                          this.setState({
                            errorName: ""
                          });
                    }
                      }}
                  />
                )}
              </Row>
              {this.state.errorName && (<Row><span style={{ color: "red", fontSize: "13px" }}>{this.state.errorName}</span></Row>)}
            </Fragment>
          ) : (
            <Fragment>
              {data}{" "}
              {!isEmpty(record.item_description) ? (
                <i className="fontSize10">
                  {isFuelEditable ? (
                    <>
                        <Input
                          data-testid={`${this.props.dataTestId}-fuel-input`}
                          value={this.props.editedFuelPercent}
                          size="small"
                          type="number"
                          style={{ width: "20%", height: 20 }}
                          onChange={(e) =>
                            props.onFuelPercentChange(
                              "editedFuelPercent",
                              e.target.value
                            )                      
                          }
                          min="1"
                          onKeyDown={(e) =>
                            props.handleKeyDown(record, e)
                          }
                          // onBlur={(e) =>
                          //   this.handleBlur(e.target.value, index, "editedFuelPercent")
                          // }
                        />
                        &nbsp;&nbsp;{remainingString}&nbsp;&nbsp;
                        <Icon
                          type="save"
                          onClick={() =>
                            props.fuelPercentSave(record)
                          }
                          style={{ color: "#1890ff" }}
                        />&nbsp;&nbsp;
                        <Popconfirm
                          title={I18n.t("messages.cancel_confirm")}
                          onConfirm={() =>
                            props.fuelPercentCancel(record.id)
                          }
                          placement="topLeft"

                        >
                          <Icon
                            type="close"
                            style={{
                              color: "red",
                            }}
                          />
                        </Popconfirm>
                      
                    </>
                  ) : (
                    <>
                      {record.item_description}
                      &nbsp;
                      {['PERCENTAGE', 'LINE_HAUL'].includes(record.fuel_surcharge_type) && !this.props.isLocked && !this.props.isAdjusted && <EditIcon
                        handleClick={() => {
                          props.fuelPercentEdit(record);
                        }}
                      />}
                    </>
                  )}
                </i>
              ) : (
                ""
                )}{" "}{record.added_from === "MANUAL" && <sup className="textRed textBold">M</sup>}{(record?.added_from_quote && record.added_from !== "MANUAL" || false) && <sup className="textRed textBold">Q</sup>}
            </Fragment>
          );
        },
        width: 300,
      },
      {
        key: "location_id",
        title: I18n.t("general.order_type"),
        dataIndex: "location_id",
        width: 150,
        render: (data, record, index) => {
    const lineLocations = this.props.getLocationsForLine
      ? this.props.getLocationsForLine(record)
      : dataSource?.locations || [];

         const locationData = lineLocations?.find((id) => id.location_id ===record.location_id)
         const ObtainedVal = orderData?.type_of_order === "MS" 
           ? `${locationData?.order_type} - ${locationData?.loc_order_sequence || ''}` 
           : locationData?.order_type
         const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
         const isRestricted = ["transportation_charges", "fuel_surcharges"].includes(this.props.invoice_type);
         const isSingleSegment = this.props.currentSection?.is_single_segment;

         
         // CHANGE - use lineLocations instead of dataSource?.locations
         const sortedLocations = [...(lineLocations || [])].sort((a, b) => {
           const seqA = a.loc_order_sequence || 0;
           const seqB = b.loc_order_sequence || 0;
           return seqA - seqB;
         });
         
         if (!isRestricted || !isSingleSegment) {
          return (
            record.isNew && !this.state.isSaved || isEditing ? (
              <Fragment>
                <Select
                  data-testid={`${this.props.dataTestId}-ordertype-dropdown`}
                  showSearch
                  value={record.location_id}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => {
                    this.props.handleOnChange(
                      index,
                      "location_id",
                      e,
                      this.props.currentSection.order_number
                    );
                    this.setState({orderType:record.location_id})
                  }}
                  size="small"
                  style={{ width: this.state.isSubItemList ? "95%" : "100%" }}
                >
                  {
                    ["T","LH"].includes(dataSource?.type_of_order && dataSource.locations.length > 1) ? (
                      <Fragment>
                        <Select.Option value=""> 
                          ---Select---
                        </Select.Option>
                        {
                          sortedLocations?.map((orderType) => (
                            <Select.Option
                              key={orderType.location_id}
                              value={orderType.location_id}
                            >
                              {orderData?.type_of_order === "MS" 
                                ? `${orderType.order_type} - ${orderType.loc_order_sequence || ''}` 
                                : orderType.order_type 
                              }
                            </Select.Option>
                          ))
                        }
                      </Fragment>
                    ) :  
                    sortedLocations?.map((orderType) => (
                        <Select.Option
                          key={orderType.location_id}
                          value={orderType.location_id}
                        >
                          {orderData?.type_of_order === "MS" 
                            ? `${orderType.order_type} - ${orderType.loc_order_sequence || ''}` 
                            : orderType.order_type 
                          }
                        </Select.Option>
                      ))
                  }
                </Select>
                {!isEmpty(this.state.orderError) && isEmpty(record.location_id) ? <Row><span style={{ color: "red", fontSize: "13px" }}>{this.state.orderError}</span></Row> : ""}
              </Fragment>
            ) : (
              <Fragment>{ObtainedVal}</Fragment>
            )
          )} else{
            return null
          };
        }
      },
      {
        key: "gl_code",
        title: I18n.t("invoices.gl_code"),
        dataIndex: "gl_code",
        width: 150,
        render: (data, record, index) => {
          const dataSource= this.props.data;
          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const child = record.isNew && !this.state.isSaved || isEditing ? (
            <Fragment>
                <GLCodeSelect
                  data-testid={`${this.props.dataTestId}-glcode-dropdown`}
                  invoiceType={this.props.invoice_type}
                  defaultValue={
                    !this.props.groupGlByWarehouseSetting
                      ? (record?.gl_code || this.props.defaultTransportationChargeGLCode)
                      : ""
                  }
                  data={this.props.glCodesList || []}
                  value={this.state.invoiceCode}
                  onChange={(e) => {
                    this.props.handleOnChange(
                      index,
                      "gl_code",
                      e,
                      this.props.currentSection.order_number
                    );
                    this.setState({ invoiceCode: e })
                  }}
                  selectKey={"gl_code"}
                  selectValue={"gl_code"}
                  selectedValue={"gl_code"}
                  selectedCode={"description"}
                  style={{ width: 120 }}
                  showSearch={true}
                  placeholder={I18n.t("invoices.gl_code")}
                  dropdownMatchSelectWidth={false}
                  size="small"
                  isEditing={isEditing}
                /> 
                {/*  } */}
                {!isEmpty(this.state.glCodeError) && isEmpty(this.state.invoiceCode) ? <Row><span style={{ color: "red", fontSize: "13px" }}>{this.state.glCodeError}</span></Row> : ""}
              </Fragment>
            // )
          ) : (
            <Fragment>
               {data || ""} 
            </Fragment>
          )
          const obj = {
            children: child,
            props: {}
          };
          return obj;
        }
      },
      {
        key: "invoice_quantity",
        title: I18n.t("invoices.units"),
        dataIndex: "invoice_quantity",
        width: 100,
        render: (data, record, index) => {
          let spanValue = ""
          if(!isEmpty(record.order_item_group_id)){
            spanValue = this.findSpanValue(this.props.data, record, index)
          }
          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const children = record.isNew && !this.state.isSaved || isEditing ? (
            <Fragment>
              <Input
                data-testid={`${this.props.dataTestId}-quantity-input`}
                type="number"
                value={this.state.invoiceQuantity}
                min="1"
                size="small"
                style={{ width: this.state.isSubItemList ? "90%" : "100%" }}
                onChange={(e) =>
                {
                  this.setState({ invoiceQuantity: e.target.value })
                  if (this.props.invoice_type === "accessorial_charges" || isEditing) {
                    this.props.handleOnChange(
                      index,
                      "invoice_quantity",
                      e.target.value,
                      this.props.currentSection.order_number
                    )
                  }
                }
                }
              />
            </Fragment>
          ) : (
            <Fragment>{!isEmpty(spanValue) ? spanValue : (data || "")}</Fragment>
          )
          const obj = {
            children,
            props: {}
          };
          if(!isEmpty(spanValue)){
            obj.props.rowSpan = spanValue
            return obj;
          }
          return obj;
        },
        align: "center"
      },
      {
        key: "invoice_value",
        title: I18n.t("invoices.amount"),
        dataIndex: "invoice_value",
        width: 150,
        render: (data, record, index) => {
          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const children = record.isNew && !this.state.isSaved || isEditing ? (
            <Fragment>
              <Row>
                <Input
                  data-testid={`${this.props.dataTestId}-amount-input`}
                  type="number"
                  value={this.state.invoiceAmount}
                  placeholder={I18n.t("invoices.amount")}
                  size="small"
                  style={{ width: '100%' }}
                  prefix={I18n.t("general.price_symbol")}
                  onChange={(e) => {
                    this.setState({ invoiceAmount: e.target.value });
                    this.props.handleOnChange(
                      index,
                      "invoice_value",
                      e.target.value,
                      this.props.currentSection.order_number
                    );
                  }}
                />
              </Row>
              {!isEmpty(this.state.error) && isEmpty(this.state.invoiceAmount)? <Row><span style={{ color: "red", fontSize: "13px" }}>{this.state.error}</span></Row> : ""}
            </Fragment>
          ) : (
            <Fragment>{checkNegitive(data)}</Fragment>
          )
          const obj = {
            children,
            props: {}
          };
          if(!isEmpty(record.order_item_group_id)){
            obj.props.rowSpan = this.findSpanValue(this.props.data, record, index)
            return obj;
          }
          return obj;
        },
        align: "right"
      },
      {
        key: "actions",
        title: "",
        dataIndex: "isNew",
        width: 100,
        render: (data, record, index) =>{
          const { showEditIcon = false } = this.props;
          const currentRowIndex = this.props.data.findIndex(rec => rec.id === record.id || (!isEmpty(record.order_item_group_id) && rec.order_item_group_id === record.order_item_group_id));
          const isLastRow = currentRowIndex < 0 ? true : currentRowIndex + 1 === this.props.data.length 
          const checkLocationLength = this.props.orderData?.locations?.length > 1
          const showCharges = (this.props.showAddIcon && isLastRow && this.props.hasNew) || (this.props.showAddIcon && isLastRow && this.props.hasNew && (!this.props.isLocked))
          const showDelete = (!record.isNew && !this.state.isSaved && this.props.showActions === true) || ((!this.props.isLocked))
          const showEdit = ( !record.isNew && !this.state.isSaved && this.props.showActions === true) || ((!this.props.isLocked))
          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const locationData = dataSource?.locations?.find((id) => id.location_id ===record.location_id)
          const ObtainedValActions = orderData?.type_of_order === "MS" 
            ? `${locationData?.order_type} - ${locationData?.loc_order_sequence || ''}` 
            : locationData?.order_type
          const hasExpandedChargeLines = this.props.isSingleInvoiceLine && record?.added_from === 'AUTO';
          const handleEdit = this.props.isSubItemList ? this.props.handleEditIndvItem : this.props.handleEditItem;
          const handleCancel = this.props.isSubItemList ? this.props.indvCancelEditItem : this.props.cancelEditItem;

          const children = this.props.isLocked ? <Fragment /> :
            (record.isNew && !this.state.isSaved ? (
              <Row type="flex" align="middle" gutter={4}>
                <Col span={8}>
                  {checkServiceExistance("CINL") && (
                    <Tooltip placement="topLeft" title="Save">
                      <Icon 
                        data-testid={`${this.props.dataTestId}-save-icon`}
                        type="save" 
                        theme="twoTone" 
                        style={{ fontSize: 14, cursor: 'pointer' }}
                        onClick={() => {
                          const isGlCodeEmpty = _.trim(this.state.invoiceCode).length === 0
                          if (isEmpty(this.state.invoiceAmount) || isEmpty(this.state.invoiceName) || isEmpty(record.location_id) || isGlCodeEmpty) {
                            this.setState({
                              error: isEmpty(this.state.invoiceAmount) ? "Cannot be blank" : "",
                              glCodeError: isEmpty(this.state.invoiceCode) ? "Cannot be blank" : "",
                              errorName: isEmpty(this.state.invoiceName) ? (this.props.invoice_type === "accessorial_charges" ? "Select the accessorial" : "Cannot be blank") : this.state.errorName,
                              orderError:isEmpty(record.location_id) ? "Cannot be blank" : ""
                            });
                          } else if (this.checkInvoiceNameConflict(this.state.invoiceName)) {
                            this.setState({
                              errorName: "Please change the description, it's already configured in accessorial level"
                            });
                          } else {
                            this.props.saveItem(index, this.props.invoice_type, this.props.currentSection.order_number, {
                              invoice_name: this.state.invoiceName,
                              gl_code: this.state.invoiceCode,
                              invoice_quantity: this.state.invoiceQuantity,
                              invoice_value: this.state.invoiceAmount,
                            });
                            this.setState({
                              applyDriverPay: false,
                              isAutoChargeModified: false,
                              invoiceName: "",
                              invoiceCode: "",
                              invoiceQuantity: 1,
                              invoiceAmount: "",
                              isSaved: true,
                              error: "",
                              glCodeError: "",
                              errorName: "",
                              orderType: checkLocationLength ? "" : this.props.orderData?.locations[0]?.location_id,
                              orderError:""
                            });
                          }
                        }}
                      />
                    </Tooltip>
                  )}
                </Col>
                <Col span={8}>
                  {checkServiceExistance("BLDINVI") && (
                    <Tooltip placement="topLeft" title="Delete">
                      <Popconfirm
                        placement="left"
                        title={I18n.t("messages.delete_confirm")}
                        onConfirm={() => {
                          this.props.deleteClick(
                            index,
                            this.props.invoice_type,
                            this.props.currentSection.order_number,
                            this.state.isSubItemList
                          )
                          this.setState({
                            applyDriverPay: false,
                            isAutoChargeModified: false,
                            invoiceName: "",
                            invoiceCode: "",
                            invoiceQuantity: 1,
                            invoiceAmount: "",
                            error: "",
                            glCodeError: "",
                            errorName: '',
                            orderType:"",
                            orderError:""
                          })
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Icon data-testid={`${this.props.dataTestId}-close-icon`} type="close" style={{ fontSize: 14, cursor: 'pointer' }} />
                      </Popconfirm>
                    </Tooltip>
                  )}
                </Col>
              </Row>
            ) : (
              <Row type="flex" align="middle" gutter={4}>
                {hasExpandedChargeLines ? null : this.props.invoice_type !== "accessorial_charges" && showEditIcon === true && showEdit && !isEditing ? (
                  <Col span={8}>
                    <Tooltip placement="topLeft" title={this.props.isAdjusted ? "Already Adjusted" : "Edit"}>
                      <Icon
                        data-testid={`${this.props.dataTestId}-edit-icon-${index}`}
                        component={EstEditGlyph}
                        onClick={() => {
                          if (this.props.isAdjusted) return;
                          const updateRecord = {
                            ...record,
                            isEditing: true,
                          };
                          handleEdit(
                            index,
                            this.props.invoice_type,
                            _.get(record, "id", ""),
                            updateRecord,
                            dataSource.locations
                          );

                          if (["transportation_charges", "fuel_surcharges"].includes(this.props.invoice_type) && record.added_from === "AUTO") {
                            setTimeout(() => {
                              this.props.handleOnChange(
                                index,
                                "is_modified",
                                true,
                                this.props.currentSection.order_number
                              );
                            }, 50);
                          }

                          this.setState({
                            applyDriverPay: record.apply_driver_pay_for_adjustment,
                            isAutoChargeModified: true,
                            isSaved: false,
                            recordForEdit: record,
                            invoiceName: record.invoice_name,
                            invoiceCode: record.gl_code,
                            invoiceQuantity: record.invoice_quantity,
                            invoiceAmount: record.invoice_value,
                            orderType: ObtainedValActions,
                          });
                        }}
                        style={{fontSize: 14, cursor: this.props.isAdjusted ? 'not-allowed' : 'pointer'}}
                      />
                    </Tooltip>
                  </Col>
                ) : isEditing && (
                  <>
                    <Col span={8}>
                      <Icon
                        data-testid={`${this.props.dataTestId}-save-icon`}
                        type="save"
                        theme="twoTone"
                        onClick={() => {
                          const isGlCodeEmpty = _.trim(this.state.invoiceCode).length === 0;

                          if (
                            isEmpty(this.state.invoiceAmount) ||
                            isEmpty(this.state.invoiceName) ||
                            isEmpty(record.location_id) ||
                            isGlCodeEmpty
                          ) {
                            this.setState({
                              error: isEmpty(this.state.invoiceAmount) ? "Cannot be blank" : "",
                              glCodeError: isEmpty(this.state.invoiceCode) ? "Cannot be blank" : "",
                              errorName: isEmpty(this.state.invoiceName)
                                ? this.props.invoice_type === "accessorial_charges"
                                  ? "Select the accessorial"
                                  : "Cannot be blank"
                                : this.state.errorName,
                              orderError: isEmpty(record.location_id) ? "Cannot be blank" : "",
                            });
                          } else {
                            this.props.editSave(
                              index,
                              this.props.invoice_type,
                              this.props.currentSection.order_number,
                              _.get(record, "id", "")
                            );
                          }
                        }}
                        style={{ fontSize: 14, cursor: 'pointer' }}
                      />
                    </Col>
                    <Col span={8}>
                      <Icon
                        data-testid={`${this.props.dataTestId}-close-icon`}
                        type="close"
                        onClick={() => {
                          handleCancel(
                            index,
                            this.props.invoice_type,
                            _.get(record, "id", ""),
                            this.props?.orderData?.order_id
                          );
                          this.setState({
                            applyDriverPay: false,
                            isAutoChargeModified: false,
                            recordForEdit: null,
                            invoiceName: "",
                            invoiceCode: "",
                            invoiceQuantity: 1,
                            invoiceAmount: "",
                            orderType: "",
                          });
                        }}
                        style={{ fontSize: 14, cursor: 'pointer' }}
                      />
                    </Col>
                  </>
                )}
                {hasExpandedChargeLines ? null : showDelete && !isEditing && (
                  <Col span={8}>
                    {this.props.isAdjusted ? (
                      <Tooltip placement="topLeft" title="Already Adjusted">
                        <Icon
                          data-testid={`${this.props.dataTestId}-delete-icon-${index}`}
                          component={EstDeleteGlyph}
                          style={{
                            fontSize: 14,
                            color: "gray",
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip placement="topLeft" title="Delete">
                        <Popconfirm
                          placement="left"
                          title={I18n.t("messages.delete_confirm")}
                          onConfirm={() =>
                            this.props.deleteClick(
                              index,
                              this.props.invoice_type,
                              this.props.currentSection.order_number,
                              this.state.isSubItemList
                            )
                          }
                          okText="Yes"
                          cancelText="No"
                        >
                          <Icon data-testid={`${this.props.dataTestId}-delete-icon-${index}`} component={EstDeleteGlyph} style={{ fontSize: 14, color: "red", cursor: 'pointer' }} />
                        </Popconfirm>
                      </Tooltip>
                    )}
                  </Col>
                )}
                {this.state.isSubItemList ? null : showCharges && !isEditing && !this.props.isAdjusted && (
                  <Col span={8}>
                    <Tooltip
                      placement="topLeft"
                      title={
                        this.props.invoice_type === "accessorial_charges"
                          ? I18n.t("accessorials.add")
                          : "Add Charge"
                      }
                    >
                      {!_.isEmpty(this.state.recordForEdit) ? (
                        <Popconfirm
                          title="Current editing progress will be lost. Are you sure?"
                          onConfirm={() => {
                            this.setState({
                              recordForEdit: null,
                              applyDriverPay: false,
                              isAutoChargeModified: false,
                              invoiceName: "",
                              invoiceCode: "",
                              invoiceQuantity: 1,
                              invoiceAmount: "",
                              orderType: "",
                            });
                            this.props.addItem(
                              this.props.invoice_type,
                              this.props.currentSection.order_number,
                              dataSource.locations,
                              this.props.currentSection
                            );
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Icon
                            data-testid={`${this.props.dataTestId}-add-icon-${index}`}
                            component={EstAddGlyph}
                            style={{ fontSize: 14, cursor: 'pointer' }}
                          />
                        </Popconfirm>
                      ) : (
                        <Icon
                          data-testid={`${this.props.dataTestId}-add-icon-${index}`}
                          component={EstAddGlyph}
                          onClick={() =>
                            this.props.addItem(
                              this.props.invoice_type,
                              this.props.currentSection.order_number,
                              dataSource.locations,
                              this.props.currentSection
                            )
                          }
                          style={{ fontSize: 14, cursor: 'pointer' }}
                        />
                      )}
                    </Tooltip>
                  </Col>
                )}
                <Col span={8}></Col>
              </Row>
            ))
          const obj = {
            children,
            props: {}
          };
          if(!isEmpty(record.order_item_group_id)){
            obj.props.rowSpan = this.findSpanValue(this.props.data, record, index)
            return obj;
          }
          return obj;
        },
        align: "right",


      },
    ];
    // Insert the applyDriverPayColumn at position 2 if invoice_type is adjustment_charges
    if (this.props.invoice_type === "adjustment_charges") {
      columns.splice(2, 0, {
        key: "apply_driver_pay_for_adjustment",
        title: I18n.t("accessorials.eligible_for_driver_pay"),
        dataIndex: "apply_driver_pay_for_adjustment",
        render: (data, record, index) => {
          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const isNew = record.isNew && !this.state.isSaved;

          // In editing mode or new record, show checkbox
          if (isNew || isEditing) {
            return (
              <Fragment>
                <Checkbox
                  data-testid={`${this.props.dataTestId}-driver-pay-check`}
                  checked={
                    record.apply_driver_pay_for_adjustment === true ||
                    record.apply_driver_pay_for_adjustment === "true"
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    this.setState({
                      applyDriverPay: checked,
                    });
                    // Use handleOnChange directly without updating state
                    this.props.handleOnChange(
                      index,
                      "apply_driver_pay_for_adjustment",
                      checked,
                      this.props.currentSection.order_number
                    );
                  }}
                />
              </Fragment>
            );
          }
          // In view mode, show Yes/No
          else {
            const value = data === true || data === "true" ? "Yes" : "No";
            return <Fragment>{value}</Fragment>;
          }
        },
        // width: 100,
        align: "center",
      });
    }
    // Insert the No Modify column at position 2 if invoice_type is transportation_charges and fuel_surcharges
if ((this.state.isSubItemList || !this.props.isSingleInvoiceLine) && ["transportation_charges", "fuel_surcharges"].includes(this.props.invoice_type)) {      columns.splice(2, 0, {
        key: "is_modified",
        title: I18n.t("invoice_lines.no_calc"),
        dataIndex: "is_modified",
        width: 100,
        align: "center",
        render: (data, record, index) => {
          let spanValue = "";

          // same span logic as your quantity column
          if (!isEmpty(record.order_item_group_id)) {
            spanValue = this.findSpanValue(this.props.data, record, index);
          }

          const isEditing = this.state.recordForEdit?.id === record.id && record.isEditing;
          const isNew = record.isNew && !this.state.isSaved;

          // if not auto added, hide cell (and prevent spanning issues)
          if (record.added_from !== "AUTO") {
            return {
              children: null,
              props: {
                rowSpan: spanValue || 1,
              },
            };
          }

          let children;

          // Editing or New → Show Checkbox
          if (isNew || isEditing) {
            children = (
              <Fragment>
                <Checkbox
                  checked={
                    this.state.isAutoChargeModified === true ||
                    this.state.isAutoChargeModified === "true"
                  }
                  onChange={(e) => {
                    const checked = e.target.checked;
                    this.setState({
                      isAutoChargeModified: checked,
                    });

                    this.props.handleOnChange(
                      index,
                      "is_modified",
                      checked,
                      this.props.currentSection.order_number
                    );
                  }}
                />
              </Fragment>
            );
          } else {
            // View Mode → Show Checkbox (clickable)
            children = (
              <Fragment>
                <Checkbox
                  disabled={this.props.isLocked}
                  checked={record.is_modified === true || record.is_modified === "true"}
                  onChange={e => {
                    const checked = e.target.checked;
                    this.setState({
                      isAutoChargeModified: checked,
                    });
                    this.props.onNoModifyChange(
                      record,
                      checked,
                      this.state.isSubItemList,
                      this.props.invoice_type,
                      this.props.currentSection.order_number
                    );
                  }}
                />
              </Fragment>
            );
          }

          const obj = {
            children,
            props: {},
          };

          if (!isEmpty(spanValue)) {
            obj.props.rowSpan = spanValue;
            return obj;
          }

          return obj;
        },
      });
    }
    this.columns = [...columns];
  }

  findSpanValue = (dataSource, record, index) => {
    const valueIndex = _.findIndex(dataSource, {order_item_group_id: record.order_item_group_id});
    if(index === valueIndex){
      const rowSpan = dataSource.filter(rec => rec.order_item_group_id === record.order_item_group_id).length
      return rowSpan;
    }
    return 0;
  }

  componentDidMount() {
    if(this.props.invoice_type === "accessorial_charges"){
      const accessorialCodeColumn =
      {
        key: "accessorial_code",
        title: I18n.t("general.code"),
        dataIndex: "accessorial_code",
        render: (data, record, index) => data || "",
        width: 100,
        align: "left",
      }

      this.columns.splice(2, 0, accessorialCodeColumn);
    }
    const dataSource = this.props.orderData?.type_of_order === "MS" && this.props.screenType === "ManageBilling" ? this.props.orderDataWithLocations : this.props.orderData;
    
    if(dataSource && dataSource?.locations?.length === 1){
      this.setState({orderType:dataSource?.locations[0]?.location_id})
    }
    this.setUniqData();
  }

  setUniqData = () => {
    const dataSource = this.props.data || [];
    const uniqRows = [];
    dataSource.forEach(rec => {
      if(!isEmpty(rec.order_item_group_id)){
        if(_.findIndex(uniqRows, { order_item_group_id: rec.order_item_group_id}) < 0){
          uniqRows.push(rec)
        }
      } else {
        uniqRows.push(rec)
      }
    });
    this.setState({
      uniqRows,
      isSaved: false
    })
  }

  resetEditState = () => {
  this.setState({
    recordForEdit: null,
    applyDriverPay: false,
    isAutoChargeModified: false,
    invoiceName: "",
    invoiceCode: "",
    invoiceQuantity: 1,
    invoiceAmount: "",
    orderType: "",
    error: "",
    glCodeError: "",
    errorName: "",
    orderError: "",
  });
};

  checkInvoiceNameConflict = (invoiceName) => {
    const { accessorials } = this.props;

    return accessorials.some(accessorial =>
      accessorial.accessorial_name.toLowerCase().trim() === invoiceName.toLowerCase().trim()
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if(!equal(prevProps.data, this.props.data)) {
       this.setUniqData();
       this.columns = [];
       this.setColumns(this.props);
    }

    // reset meant ONLY for parent table
    if (
      !this.state.isSubItemList &&
      prevProps.removeEditingVals !== this.props.removeEditingVals &&
      this.props.removeEditingVals !== null
    ) {
      const isCancelledItemInThisTable = this.props.data?.some(
        item => item.id === this.props.removeIndvEditingVals
      );

      if (isCancelledItemInThisTable) {
        this.resetEditState();
      }
    }

    // reset meant ONLY for expanded table
    if (
      this.state.isSubItemList &&
      prevProps.removeIndvEditingVals !== this.props.removeIndvEditingVals &&
      this.props.removeIndvEditingVals !== null
    ) {
      const isCancelledItemInThisTable = this.props.data?.some(
        item => item.id === this.props.removeIndvEditingVals
      );

      if (isCancelledItemInThisTable) {
        this.resetEditState();
      }
    }
  }
}

export default InvoicesList;

InvoicesList.propTypes = {
  showHeadings: PropTypes.bool,
  accessorials: PropTypes.array.isRequired,
  hasEditingErrors: PropTypes.bool,
  isAdjusted: PropTypes.bool,
  isSingleInvoiceLine: PropTypes.bool,
  expandedRowId: PropTypes.string,
  onNoModifyChange: PropTypes.func,
  title: PropTypes.string,
  showAddIcon: PropTypes.bool,
  getLocationsForLine: PropTypes.func,
};

InvoicesList.defaultProps = {
  showEditIcon: false,
  accessorials: [],
  hasEditingErrors: false,
  isAdjusted: false,
  isSingleInvoiceLine: false,
  expandedRowId: "",
  onNoModifyChange: () => {},
  dataTestId: 'invoice-list',
  showAddIcon: false,
  getLocationsForLine: null,

};